import React, { createContext, useContext, useEffect, useState } from "react";

const NetworkContext = createContext();

export const NetworkProvider = ({ children }) => {
  const [isNetworkError, setIsNetworkError] = useState(false);
  // 🔁 auto recover when internet is back
  useEffect(() => {
    const online = () => setIsNetworkError(false);
    const offline = () => setIsNetworkError(true);

    window.addEventListener("online", online);
    window.addEventListener("offline", offline);

    return () => {
      window.removeEventListener("online", online);
      window.removeEventListener("offline", offline);
    };
  }, []);

  return (
    <NetworkContext.Provider value={{ isNetworkError, setIsNetworkError }}>
      {children}
    </NetworkContext.Provider>
  );
};

export const useNetwork = () => useContext(NetworkContext);
